import { TypedUseSelectorHook, useSelector } from "react-redux";
import { ApplicationState } from "../appState";

/** 
 *  Strongly typed redux hook for our app state.
 *  Use this as a quick alternative to connect() when selecting a small number of redux props.
 */
export const useAppState: TypedUseSelectorHook<ApplicationState> = useSelector;